import "./index.css";

import React from "react";
import ReactDOM from "react-dom";

import App from "./App";

// Dynamically load EUI theme CSS based on dark mode preference
const darkMode = localStorage.getItem("darkMode") || false;
const euiThemeLink = document.createElement("link");
euiThemeLink.rel = "stylesheet";
euiThemeLink.type = "text/css";
euiThemeLink.href = darkMode ? "/eui_theme_dark.css" : "/eui_theme_light.css";
document.head.appendChild(euiThemeLink);

ReactDOM.render(<App />, document.getElementById("root"));
